<template>
  <div class="mfe-3 font-lg">
    <PageHintRouter class="d-inline-block mfe-3 font-xl" />
    <!-- <span id="notification-bell" class="mfe-3 position-relative cursor-pointer font-xl" style="vertical-align: middle;"
      @click="hideNotif()">
      <span id="unseen-badge"></span>
      <FaIcon icon="bell" class="text-affili-coral" style="vertical-align: middle;" />
    </span> -->
    <span id="notification-bell"
      class="mfe-3 position-relative cursor-pointer font-xl"
      style="vertical-align: middle;"
      @click="$router.push({name: 'notifications'})"
      v-if="$policy('notification').view_list"
    >
      <span v-if="$currentUser().unread_notifications > 0" id="unseen-badge">{{ $currentUser().unread_notifications }}</span>
      <FaIcon icon="bell" class="text-affili-coral" style="vertical-align: middle;" />
    </span>
    <span>
      <FaIcon icon="wallet" class="font-xl" style="vertical-align: middle;" />
      <span class="mfs-1 font-sm">{{ $commas($currentUser().balance) }} {{ $t('rial') }}</span>
    </span>
  </div>
</template>

<script>
import PageHintRouter from './PageHintRouter'
// import novuConfig from './novuConfig'
// import { UserSetupStatus } from '@/constants'

export default {
  name: "General",

  components: {
    PageHintRouter
  },

  methods: {
    // hideNotif() {
    //   let notif = document.querySelector('#novu-container')

    //   if (notif.style.display !== 'none' && !notif.classList.contains('force-hide')) {
    //     notif.classList.add('force-hide')
    //   } else {
    //     notif.classList.remove('force-hide')
    //   }
    // },
    // initNovu(accountId, devSubscriber) {
    //   if (this.$currentUser().setup_status !== UserSetupStatus.COMPLETE) {
    //     return;
    //   }

    //   novu.init(accountId, novuConfig, {
    //     subscriberId: 'affili-' + (devSubscriber ? devSubscriber : this.$currentUser().id),
    //     first_name: this.$currentUser().first_name,
    //     last_name: this.$currentUser().last_name,
    //     phone: this.$currentUser().phone,
    //     email: this.$currentUser().email,
    //     data: {
    //       role: this.$currentUser().role.name
    //     }
    //   });
    // }
  },

  mounted() {
    // this.initNovu(
    //   process.env.VUE_APP_NOVU_APPLICATION_IDENTIFIER,
    //   process.env.VUE_APP_NOVU_DEV_ID && process.env.VUE_APP_NOVU_DEV_ID.length > 0 ? process.env.VUE_APP_NOVU_DEV_ID : false
    // )
  }
}
</script>

<style scoped lang="scss">
::v-deep #unseen-badge {
  position: absolute;
  top: -8px;
  right: -15px;
  text-align: center;
  background: red;
  border-radius: 100%;
  height: 31px;
  width: 31px;
  scale: .6;
  color: #fff;
  border: 3px solid #fff;
}
</style>

<style>
/* .wrapper-novu-widget {
  direction: ltr;
}

@media screen and (max-width: 425px) {
  .wrapper-novu-widget {
    scale: 0.75;
    left: 0px !important;
    top: 40px !important;
  }
}

.force-hide {
  display: none !important;
}

#novu-iframe-element {
  position: absolute;
} */
</style>